
/**
 * 
 * Only add methods that apply to both apps and reports. 
 * If the function is specific to one of them use AppService or ReportService.
 * 
 **/

import util from 'util/Util';
import _ from 'lodash';
import Spinner from 'spin/spin';
import Base64Encoder from 'util/Base64Encoder.js';
import { Model } from 'backbone';
import constants from 'Constants.js';
import textConstants from 'TextConstants';
import mobileConstants from "../../mobile/commons/MobileFormsConstants";

import eventBus from 'EventBus.js';
import restService from 'RestService';
import configService from 'ConfigService';
import listService from 'ListService.js';
import appLoadService from 'FormLoadService.js';
import notificationService from 'NotificationService';
import mobileListService from 'mobile/MobileListService';
import restServiceAux from "RestServiceAux";
import undoService from 'UndoService.js';

import LinkModal from 'dashboard/LinkModal.js';
import RecoverDesignModal from 'dashboard/forms/modal/RecoverDesignModal';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import AlertDialogView from 'common-views/AlertDialogView.js';
import ConfirmationModal from 'dashboard/forms/modal/ConfirmationModal';
import SelectFileModal from 'common-views/SelectFileModal.js';
import MigrateFormModal from 'dashboard/forms/modal/MigrateFormModal.js';
import MigrateReportModal from 'dashboard/reports/modal/MigrateReportModal.js';
import DeleteModal from 'dashboard/forms/modal/FormDeleteModal.js';
import ReportDeleteModal    from 'dashboard/reports/modal/ReportDeleteModal.js';
import PermissionsModal    from 'dashboard/PermissionsModal.js';
import MobileConfirmationModal    from 'dashboard/forms/modal/MobileConfirmationModal';

import ReportDetailsView from 'dashboard/reports/ReportDetailsView.js'
import AppDetailsView from 'dashboard/forms/FormDetailsView.js'
import AppSimpleView from 'dashboard/forms/ViewableInstanceView.js'

class CommonService {

    constructor() {
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });        
    }

    getHostUrl() {
        return this.hostUrl;
    }

    getModel(id, type, createModelFx) {

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (type === "app") {
                    restService.getFormDetails(id).then((detailsResult) => {
                        const newModel = createModelFx(id, detailsResult);
                        resolve(newModel);
                    }).catch((error) => {
                        const msg = error || 'Unknown Error';
                        notificationService.error(msg);
                    });
                }
                else {
                    restService.getReportDetails(id).then((detailsResult) => {
                        const newModel = createModelFx(id, detailsResult);
                        resolve(newModel);
                    }).catch((error) => {
                        const msg = error || 'Unknown Error';
                        notificationService.error(msg);
                    });
                }
            }, 50);
        });

    }

    getBasicModel(id, appName, createModelFx){

        return new Promise((resolve, reject) => {
            restService.searchViewableFormInstanceDetails(id).then((detailsResult)=> {
                const viewableDetails = detailsResult.RESULT.RESPONSE;
               
                const newModel = createModelFx(id, appName, viewableDetails);
                let instances = null;
                if (viewableDetails.InstanceList) {
                    instances = viewableDetails.InstanceList.Instance instanceof Array
                        ? viewableDetails.InstanceList.Instance
                        : [viewableDetails.InstanceList.Instance];
                }
                newModel.set('gridData', instances, {silent: true});
    
                resolve(newModel);              
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                notificationService.error(msg);
            });;    
        });
    }

    getAll(type){
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
       

        return new Promise((resolve, reject) => {

            if (type === "app") {
                restService.getAllApps().then((data) => {

                    if(data.RESULT.RESPONSE.AppListSummary){
                        resolve(data.RESULT.RESPONSE.AppListSummary.app);
                    }
                    else{
                        resolve();
                    }
                    spinner.stop();
                }).catch((error) => {
                    console.log(error);
                    notificationService.error(error);
                    spinner.stop();
                });
            }
            else {
                restService.getAllReports().then((data) => {
                    if(data.RESULT.RESPONSE.ReportListSummary){
                        resolve(data.RESULT.RESPONSE.ReportListSummary.report);
                    }
                    else{
                        resolve();
                    }
                    spinner.stop();
                }).catch((error) => {
                    console.log(error);
                    notificationService.error(error);
                    spinner.stop();
                });
            }
        });
    }

    loadDesigner(model, type){
        
        listService.dashboardLayout.mainPanelView.model = model

        const id = model.get("formId") || model.get("reportId");
        const name = model.get("formName") || model.get("reportName");
        const linkId = model.get('LinkId');
        const versionList = model.get('versionList');
        const isDeployed = model.get('IsDeployed');
        const comesFromRecovery = model.get('ComesFromRecovery');
        const versionInfo = this.getSelectedVersionId(versionList, isDeployed, false);
        const listIndex = this.findVersionIndex(versionList, versionInfo);

        const majorVersion = versionList instanceof Array ? versionList[listIndex]['@MajorVersion'] : versionList['@MajorVersion'];
        const minorVersion = versionList instanceof Array ? versionList[listIndex]['@MinorVersion'] : versionList['@MinorVersion'];
        const lastUpdateDate = model.get("lastUpdateUTC");

        const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));

        restService.getConnections().then((connections) => { //Preload connections
            window.sessionStorage.setItem('pfConnections', JSON.stringify(connections));
        }).then(() => {

            if (type === "app") {
                appLoadService.loadForm(id, majorVersion, minorVersion, linkId, name, versionInfo.formVersionId, lastUpdateDate, comesFromRecovery).then(msg => {
                    spin.stop();

                }, (errMsg) => {
                    notificationService.error(errMsg);
                });
            }
            else {
                appLoadService.loadReport(id, majorVersion, minorVersion, name, versionInfo.reportVersionId, lastUpdateDate, comesFromRecovery).then(msg => {
                    spin.stop();

                }, (errMsg) => {
                    notificationService.error(errMsg);
                });
            }
        });
    }

    publishValidations(model, type){
        const self = this;

        const confirmPublish = () => {

            const version = model.get('publishedVersion') || model.get('deployedVersion');
            if ( util.isTrue(model.get('responsive')) && util.isTrue(model.get('containsMobileErrors')) ) {

                const
                    alertText = 'Design elements are currently placed outside of the mobile canvas. Apps cannot be published until layout issues are resolved.',
                    alertTitle = 'Layout issues',
                    alertView = new AlertDialogView({model: new Model({text: alertText, title: alertTitle})});
    
                alertView.render();
    
            } else {
                const LastRecoveryUpdateDate = model.get('LastRecoveryUpdateDate');
                if ( version && util.isEmpty(LastRecoveryUpdateDate)) {  // Not first time publishing
                    const
                        confirmationTitle = 'Publish ' + type,
                        confirmationText =
                            '<div class="row">' +
                            '  <div class="col-sm-12">' +
                            '    <p> Are you sure you want to publish a new version of the ' + type + '? </p>'+
                            '    <p> This will replace your previously published version as the one which is shown by default for a new instance.</p>' +
                            '  </div>' +
                            '</div>';
    
                        new ConfirmationModal( {
                        model: new Model( {
                            confirmationTitle: confirmationTitle,
                            confirmationText: confirmationText,
                            height: 196,
                            width: 500
                        })
                    }).render().then(result => {
                        if ('Yes' === result) {
                            self.publish(model, type);
                        }
                    });
                } else {
                    // First time publishing
                    self.publish(model, type);
                }
            }
        }


        const checkMobileStatus = () => {
            const mobileFeatureIsEnable = model.get('mobileFeatureIsEnabled');
            const mobileFormIsEnabled = model.get('mobileFormIsEnabled');
            const mobileFormIsActive = model.get('mobileFormIsActive');
            const mobileDesignExists = model.get('mobileDesignExists');
            const mobileWizardIsCompleted = model.get('mobileWizardIsCompleted');
            const reflowEnabled = model.get('reflowEnabled');
    
            let confirmation;
    
            if(mobileDesignExists){
    
                if(mobileFormIsEnabled && !mobileFormIsActive){

                    if(!reflowEnabled){
                        confirmation = {
                                    height: 150,
                                    confirmationTitle: 'Publish App',
                                    confirmationText: `<div class="row">
                                                            <div class="col-sm-12">            
                                                                <p> ${mobileConstants.PUBLISH_FORM_ACTIVATE_MOBILE_MESSAGE_TEXT} </p>
                                                            </div>
                                                        </div>`,
                                    buttons : [
                                                {
                                                    text: 'Activate Mobile',
                                                    resolve: "activateMobile"
                                                },
                                                {
                                                    text: "Don't Activate",
                                                    resolve: "dontActivateMobile"
                                                }]
                                    }
                    }
                    else{
                        confirmation = {
                            confirmationTitle: 'Publish App',
                            confirmationText: `<div class="row">
                                                    <div class="col-sm-12">            
                                                        <p> ${mobileConstants.PUBLISH_FORM_ACTIVATE_MOBILE_REFLOW_MESSAGE_TEXT} </p>
                                                    </div>
                                                </div>`,
                            buttons : [
                                        {
                                            text: 'Activate Mobile',
                                            resolve: "activateMobile"
                                        },
                                        {
                                            text: "Edit App Properties",
                                            resolve: "editApp"
                                        },
                                        {
                                            text: 'Cancel',
                                            resolve: "cancel"
                                        }]
                            }
                        }
                }
                else if(mobileFeatureIsEnable && !mobileWizardIsCompleted && mobileFormIsActive){

                    if(!reflowEnabled){
                        confirmation = {
                                    confirmationTitle: 'Publish App',
                                    confirmationText: `<div class="row">
                                            <div class="col-sm-12">            
                                                <p> ${mobileConstants.PUBLISH_FORM_MOBILE_INCOMPLETE_MESSAGE_TEXT} </p>
                                            </div>
                                        </div>`,
                                    buttons : [
                                                {
                                                    text: 'Publish Desktop',
                                                    resolve: "publish"
                                                },
                                                {
                                                    text: 'Edit Mobile App',
                                                    resolve: "edit"
                                                },
                                                {
                                                    text: 'Cancel',
                                                    resolve: "cancel"
                                                }]
                                    }
                    }
                    else{
                        confirmation = {
                            confirmationTitle: 'Publish App',
                            confirmationText: `<div class="row">
                                    <div class="col-sm-12">            
                                        <p> ${mobileConstants.PUBLISH_FORM_MOBILE_INCOMPLETE_REFLOW_MESSAGE_TEXT} </p>
                                    </div>
                                </div>`,
                            buttons : [                                       
                                        {
                                            text: 'Edit Mobile App',
                                            resolve: "edit"
                                        },
                                        {
                                            text: 'Cancel',
                                            resolve: "cancel"
                                        }]
                            }

                    }
                }
            }
    
            return confirmation;
        }


        const checkMobile = () =>{

            let confirmation = checkMobileStatus(model);
            mobileListService.mobileAutoOpenWizard = false;
    
            if(type === "app" && confirmation){
                new MobileConfirmationModal( {
                    model: new Model( {
                        confirmationTitle: confirmation.confirmationTitle,
                        confirmationText: confirmation.confirmationText,
                        height: confirmation.height,
                        width: 500,
                        buttons: confirmation.buttons
                    })
                }).render().then(result => {
                    if ('publish' === result) {
                        confirmPublish();
                    }else if('edit' === result || 'editApp' === result){
                        const designerKinds = [constants.KIND_LAYOUT, constants.KIND_WORKFLOW,constants.KIND_BEHAVIORS];
                        if (designerKinds.indexOf(listService.mainKind) === -1){

                            if(result === "edit"){
                                mobileListService.mobileAutoOpenWizard = true;
                            }
                            self.loadDesigner(model, type);
                        }else{
                            let mobileIcon = document.querySelector(`.${constants.MOBILE_ICON_ENABLED_CLASS}>i`);
                            if (mobileIcon){
                                mobileIcon.click();
                            }
                        }
                    }else if('activateMobile' === result){                   
                        model.set('mobileFormIsActive', true, constants.MODEL_SILENT);
                        setTimeout(() => {
                            confirmPublish();
                        }, 500);
                    }
                    else if('dontActivateMobile' === result){
                            confirmPublish();
                    }
                });
            }
            else{
                confirmPublish();
            }

        }

        const checkRecovery = () => {
            const lastRecoveryUpdateDate = model.get('LastRecoveryUpdateDate');
            
            if (!util.isEmpty(lastRecoveryUpdateDate)) {
                
                const recoverDate = util.formatUTC(lastRecoveryUpdateDate);
                const id = model.get("formId") || model.get("reportId");
                const lastUpdate = model.get("lastUpdateUTC");

                const recoverDesignModal = new RecoverDesignModal({ model: new Model({ formId: id, recoverDate: recoverDate, fromAction: "publish", lastUpdate: lastUpdate }) });
                recoverDesignModal.render().then(result => {
                    if (result === "recover") {
                        model.set('ComesFromRecovery', true);
                        self.loadDesigner(model, type);

                    } else if (result === "publish") {
                       checkMobile();
                    }
                });
            }
            else {
                checkMobile();
            }
        };

        

        checkRecovery();
    
    }

    publish(model, type) {
        const isInDashboard = !listService.mainKind || listService.mainKind === constants.KIND_DASHBOARD;
        let id = model.get('formId') || model.get("reportId");
        
         const validateFields = (data) => { 
          
            if (data.fieldsWithChangedDataType){
                let changedData = data.fieldsWithChangedDataType.field;
                changedData = changedData instanceof Array? changedData : [changedData];
                let items = '<br/>';

                changedData.forEach( item => {
                  items += item['@name'] + '<br/>';
                });   
                
                let message = '  <div class="col-md-12">' +
                '    Publishing the new version of the ' + type + ' resulted in the following fields having changed their data-type: <br/>'+
                items + '<br/>' +
                '    This can have unexpected effects in reports which refer to this fields. It is recommended that you verify all reports which use these fields, and if necessary re-fresh the corresponding data-sources in the reports.'+
                '</div>';
        
                let subtitle = "Publish " + type;    

                let simpleModal = new SimpleConfirmModalView({
                    model:new Model({
                        subtitle: subtitle,
                        confirmationText: message,
                        width: 500,
                        showCancel: false
                    })
                });

                simpleModal.render();
            }
        }

        if(type === "app"){
            restService.deployForm(id).then((data) => {
                validateFields(data);
                
                if (isInDashboard){
                   eventBus.trigger('reloadTable');

                }else{
                    util.updateAppReportVersion(data.DeployForm.MajorVersion + '.' + data.DeployForm.MinorVersion, true, true);
                    notificationService.success(`App version ${data.DeployForm.MajorVersion + '.' + data.DeployForm.MinorVersion} deployed.`);
                }
            }).catch((error) => {
                var msg = error || 'Unknown Error';
                console.log('error ', error);
                notificationService.error(msg);
                return (error);
            });
        }
        else{
            restService.deployReport(id).then((data) => {
                validateFields(data);
                if (isInDashboard){
                    eventBus.trigger('reloadTableReport');               
                }else{                    
                    util.updateAppReportVersion(data.DeployReport.MajorVersion + '.' + data.DeployReport.MinorVersion, true, true);
                    notificationService.success(`Report version ${data.DeployReport.MajorVersion + '.' + data.DeployReport.MinorVersion} deployed.`);
                }

            }).catch((error) => {
                var msg = error || 'Unknown Error';
                console.log('error ', error);
                notificationService.error(msg);
                return (error);
            });
        }        
    }

    openSimpleView(model, type){
        const newDetailsView = new AppSimpleView({ model: model, el: constants.DASHBOARD_MAIN_PANEL });
        listService.dashboardLayout.mainPanelView = newDetailsView;
        newDetailsView.render();      
    }

    openDetailsView(model, type){
        let selected = {
            id: model.get('formId') || model.get("reportId"),
            name: model.get('formName') || model.get("reportName"),
            groupId: model.get('GroupId'),
            groupType: model.get('groupType'),
            link: model.get('LinkId'),
            versionList: model.get('versionList'),
            totalOpenInstances: model.get('totalOpenInstances')
        };

        let newDetailsView;

        if (type === "app") {
            listService.dashboardFormsItems
                .setDefaultValue()
                .setPropValue('formItemSelected', selected);

            newDetailsView = new AppDetailsView({ model: model, el: constants.DASHBOARD_MAIN_PANEL });

        }
        else {

            let groupType = selected.groupType,
            groupId = selected.groupId;
            
            if(!groupType){
                groupType = model.get('isShared') ? constants.REPORTS_SHARED_GROUP_TYPE : constants.REPORTS_PRIVATE_GROUP_TYPE;
            }

            if(!groupId){
                groupId = `${constants.FORMS_VIEW_GROUP_TYPE}_${selected.id}`
            }

            listService.reportItemSelected = {
                reportName: selected.name, reportId: selected.id, reportLink: selected.link,
                versionList: selected.versionList.Version, groupType: groupType, groupId: groupId
            };

            model.set("groupType", groupType);
            model.set("GroupId", groupId);
            newDetailsView = new ReportDetailsView({ model: model, el: constants.DASHBOARD_MAIN_PANEL });
        }

        listService.dashboardLayout.mainPanelView = newDetailsView;
        newDetailsView.render();
    }

    openLink(id, name, model){

        const width = model.get('Width');
        const height = model.get('Height');
        const reportLink = model.get('LinkId');
        const apiReference = model.get('apiReference');
        const isDeployed = model.get('IsDeployed')
        const versionList = model.get('versionList');
        const versionInfo = this.getSelectedVersionId(versionList, isDeployed, false);
       
        var linkModal = new LinkModal({
            model: new Model({ hostUrl: this.hostUrl,
                name: name, id: Base64Encoder.encodeToString(id), link: reportLink,
                width: width, height: height, apiReference: apiReference, versionInfo: versionInfo
            })
        });
        linkModal.render().then((result)=> {
            console.log(result);
        });
    }

    
    getSelectedVersionId(vList, isDeployed, selectVersion) {
        const versionList = util.enforceArrayType(vList);
        let formVersionId;
        let isDraft = !util.isTrue(isDeployed);
       
        // PF-5014 validate if is the latest version published
        let isLatest = true;
        let versionNumber = 'latest';
       
        if(selectVersion){
            const opt = $('input[name=version]:checked');

            if (opt[0].value === 'latest') {
                formVersionId = versionList[0]['@FormVersionId'];
                if ($('select[name=draftVersion] option').length > 0 && !this.isTrue(isDeployed)){
                    isDraft = true;
                }
            }

            else if (opt[0].value === 'published') {
                const selectedVersion = $('select[name=publishedVersion] option:checked');
                formVersionId = selectedVersion.attr('formVersionId');
                isLatest = false;
                versionNumber = selectedVersion.val();
            }

            else if (opt[0].value === 'draft') {
                const selectedVersion = $('select[name=draftVersion] option:checked');
                formVersionId = selectedVersion.attr('formVersionId');
                isDraft = true;
                isLatest = false;
                versionNumber = selectedVersion.val();
            }
        }
        else{//If there is no selection form details page always open latest published version
            formVersionId = versionList[0] ? versionList[0]['@FormVersionId'] : "";
        }

        return {formVersionId: formVersionId, isDraft: isDraft, isLatest: isLatest, versionNumber: versionNumber};
    }

    findVersionIndex(versionList, versionInfo) {
        let index = 0;
        _.forEach(versionList, (item, k) => {
            if (item['@FormVersionId'] === versionInfo.formVersionId) {
                index = k;
                return k;
            }
        });
        return index;
    }

    getVersionId(version, model){
        let versionArray = version.split('.');
        let id = null;
        let versionList = model.get('versionList');

        if (versionList instanceof Array){
            let i = 0;
            do {
                let version = versionList[i];
                if (version['@MajorVersion'] === versionArray[0] && version['@MinorVersion'] === versionArray[1] ) {
                    id = version['@FormVersionId'];
                }
                ++i;
            } while (!id || i< versionList.length);
        } else {
            if (versionList['@MajorVersion'] === versionArray[0] && versionList['@MinorVersion'] === versionArray[1] ) {
                id = versionList['@FormVersionId'];
            }
        }
        return id;
    }

    getMigrationType(selection, options){
        let type = '';
        if (options.length <= 0 ){
            type = selection;
        } else {
            switch (selection) {
                case 'x' :
                    if ($.inArray('z', options) >= 0) {
                        type = 'z';
                    }
                    if ($.inArray('a', options) >= 0) {
                        type = 'a';
                    }
                    type = type + 'x';
                    break;
                case 's':
                    if ($.inArray('z', options) >= 0) {
                        type = 'z';
                    }
                    if ($.inArray('a', options) >= 0) {
                        type = 'a';
                    }
                    if ($.inArray('h', options) >= 0) {
                        type = type + 'h';
                    }
                    if ($.inArray('ss', options) >= 0) {
                        type = type + 'ss';
                    } else if ($.inArray('ts', options) >= 0) {
                        type = type + 'ts';
                    } else {
                        type = type + 'cs';
                    }
                    break;
            }
        }
        return type;
    }

    permissions(model, isApp){
        const permissionsModal = new PermissionsModal({ model: model });
        permissionsModal.render(isApp);
    }

    migrate(model, isApp) {

        const importWithFile = (file) =>{
            const id = model.get('formId') || model.get("reportId");
            let groupType = model.get('groupType');
            let groupId = model.get('groupId');

            const errorResponse = (errMsg) => {
                if (errMsg.CODE === '999') {
                    const content = 'The selected file type is not supported. ' + 
                                    'Apps and reports created in 4.x or earlier versions cannot be imported currently.';
                    const selectFileModal = new SelectFileModal({title: 'Import', 
                            itemName: content, dependencies: 'None',
                            width: 450, 
                            message: "Import Failed."
                        });
                    selectFileModal.render().then(selectedFile => {
                        // no actions required.
                    });
    
                    notificationService.error('File was not imported succesfully');
                } 
                else {
                    notificationService.error( errMsg );
                }
            }

            if (isApp === "app") {
                restService.importFormStyle(id, file.name, file.file).then((result) => {
                    const selectFileModal = new SelectFileModal({ title: 'Import', itemName: result.Import.Item['@caption'], dependencies: 'None' });
                    selectFileModal.render().then(selectedFile => {
                        eventBus.trigger("deployForm", id, groupType, groupId);
                    });
                }, (errMsg) => {
                    errorResponse(errMsg);
                });
            }
            else {
                restService.importReportStyle(id, file.name, file.file).then((result) => {
                    const selectFileModal = new SelectFileModal({ title: 'Import', itemName: result.Import.Item['@caption'], dependencies: 'None' });
                    selectFileModal.render().then(selectedFile => {
                        eventBus.trigger("deployReport", id, groupType, groupId);
                    });
                }, (errMsg) => {
                    errorResponse(errMsg);
                });
            }
        }
        
        const importDesign = () => {
            const selectFileModal = new SelectFileModal();
            selectFileModal.render().then(selectedFile => {
                if (selectedFile && selectedFile !== 'Unauthorized') {
                    importWithFile(selectedFile);
                }
            });
        }

        const exportDesign = (id, eType, name) => {                
            if (id !== null) {
                restService.exportFormResponseData(id, eType, name);
            } else {
                notificationService.error( 'No version found' );
            }
        }

        const transferOwnership = () => {
            const objectId = model.get('formId') || model.get("reportId");
            AppDetailsView.displayUserSelectionModal().then(user => {               
                restServiceAux.transferFormOwner(objectId, user.id).then( result => {
                    notificationService.success( `Ownership transferred successfully to ${user.label}` );
                    const reload = isApp === "app" ? "reloadTable" : "reloadTableReport";

                    setTimeout(() => {
                        eventBus.trigger(reload);
                    }, 100);

                }, msg => {
                    notificationService.warning(msg);
                });
    
            }, reason => {
                console.log(reason);
                notificationService.info( `Ownership transfer canceled.` );
            });
        }

        let versionList = model.get('versionList') instanceof Array ? model.get('versionList') : [model.get('versionList')];

        let versions = [];
        for (let version of versionList) {
            let versionString = version['@MajorVersion'] + '.' + version['@MinorVersion'];
            versions.push(versionString);
        }

        const isPrivate = util.isTrue(model.get('IsPrivate'));
        const isShared = model.get('groupType') === constants.REPORTS_SHARED_GROUP_TYPE;
        let migrateModal;

        if (isApp === "app") {
            migrateModal = new MigrateFormModal({
                model: new Model({
                    isPrivate: isPrivate,
                    versions: versions
                })
            });
        }
        else{
            migrateModal = new MigrateReportModal({
                model: new Model({
                    isPrivate: isPrivate,
                    versions: versions
                })
            });
        }

        migrateModal.render().then(importStyle => {
            if (importStyle && importStyle !== 'Unauthorized') {
                let type = null;
                let formId = null;
                let name = model.get('formName') || model.get("reportName");
                let ext = null;

                switch (importStyle.selection) {
                    case 'i':
                        importDesign();
                        break;
                    case 'n':
                        formId = commonService.getVersionId(importStyle.options, model);
                        type = isApp === "app" ? 'n' : 'r';
                        name = name + (isApp === "app" ? ' (App).pa' : '(Report).pa');
                        exportDesign(formId, type, name);
                        break;
                    case 'x':
                        formId = model.get('formId');
                        type = commonService.getMigrationType('x', importStyle.options);
                        ext = '.xml';
                        if (type.indexOf('z') >= 0 || type.indexOf('a') >= 0) {
                            ext = '.zip';
                        }
                        exportDesign(formId, type, name + ext);
                        break;
                    case 's':
                        type = commonService.getMigrationType('s', importStyle.options);
                        formId = model.get('formId');
                        ext = '.csv';
                        if (type.indexOf('z') >= 0 || type.indexOf('a') >= 0) {
                            ext = '.zip';
                        }
                        exportDesign(formId, type, name + ext);
                        break;
                    case constants.DASHBOARD_XFER_OWNERSHIP:
                        transferOwnership();
                        break;
                }
            } else {
                notificationService.info(`Migration canceled.`);
            }
        });
    }   
    
    delete(model, type) {

        const id = model.get('formId') || model.get('reportId');
        const name = model.get('formName') || model.get("reportName");
        const groupId = model.get('GroupId');
        const groupType = model.get('groupType');
        const link = model.get('LinkId');
        const versionList = model.get('versionList');
        let deleteModal;

        if (type === "app") {
            const totalOpenInstances = model.get('totalOpenInstances');
            deleteModal = new DeleteModal({
                model: new Model({
                    formName: name, formId: id, formLink: link,
                    versionList: versionList, totalOpenInstances: totalOpenInstances,
                    groupId: groupId, groupType: groupType,
                    hasMobileForm: !model.get('mobileFeatureIsEnabled') || (model.get('mobileFeatureIsEnabled') && !model.get('mobileFormIsActive'))
                }),
                width: 470, height: 410
            });
        }
        else {
            const parentId = model.get('parentId');
            deleteModal = new ReportDeleteModal({
                model: new Model({
                    reportName: name, reportId: id, reportLink: link,
                    versionList: versionList, groupType: groupType, groupId: groupId, parentId: parentId
                })
            });
        }

        deleteModal.render().then(result => {
            console.log(result);
        }, err => console.log(`deleteForm rejection:`, err)).catch(err => console.log(err));

    }

    setFavorite(id, objType){
        return new Promise((resolve, reject) => {
            restService.addFavorites({formIds: [id]}, objType).then(result => {
                resolve("set");
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                notificationService.error(msg);
            });            
        });
    }

    unsetFavorite(id, objType){
        return new Promise((resolve, reject) => {
            restService.removeFavorites({formId: id}, objType).then(result => {
                resolve("unset");
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                notificationService.error(msg);
            });           
        });
    }

    share(model, type) {

        let params = {
            isPrivate: !util.isTrue(model.get('IsPrivate')),
            groupId: constants.DEFAULT_GROUP_ID,
            name: constants.DEFAULT_GROUP_ID,
            groupType: model.get('groupType'),
            itemId: model.get('GroupId')
        };

        if (type === "app"){
            params.formId = model.get('formId');
        }  
        else{
            params.reportId = model.get('reportId');
        }
        
        this.shareAPICall(params, type).then(() => {

            undoService.add({
                undo:() => {
                    params.groupId = model.get('sharedGroupId');
                    params.isPrivate = true;
                    this.shareAPICall(params, type)
                },
                redo:() => {
                    params.groupId = constants.DEFAULT_GROUP_ID;
                    params.isPrivate = false;
                    this.shareAPICall(params, type)
                }
            },textConstants.UNDO_SHARE_FORM);
        });

    }

    shareAPICall(params, type){

        if(type === "app"){
            return restService.shareForm(params).then( () => {
                eventBus.trigger('reloadTable');
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                console.log('error ', msg);
                return (error);    
            });
        }
        else{
            return restService.shareReport(params).then( () => {
                eventBus.trigger('reloadTableReport');
            }).catch((error) => {
                const msg = error || 'Unknown Error';
                console.log('error ', msg);
                return (error);    
            });
        }        
    }    
}

const commonService = new CommonService();
export default commonService;